import { InputLabel, InputLabelProps } from '@mui/material';
import { ReactNode } from 'react';
import './converge-input-label.scss';

interface IConvergeInputLabelProps extends InputLabelProps {
  label: ReactNode;
  required?: boolean;
}

export const ConvergeInputLabel = ({
  label,
  required,
  sx,
  ...props
}: IConvergeInputLabelProps) => {
  return (
    <InputLabel className="coverage-input-label" sx={{ ...sx }} {...props}>
      {label}
      {required ? <span className="required-star-design">*</span> : null}
    </InputLabel>
  );
};
